<template>
  <roe-plan-design-edit-form
    :designs="designs"
    name="Service Requirement"
    :view-input="serviceRequirement"
    :form="$v.editableDesign"
  >
    <div class="right-panel-form-row-wrap">
      <div class="right-panel-label-wrap">
        <div class="light-label">
          Does the plan have a service requirement for Employee Contributions?
        </div>
      </div>
      <div class="right-panel-form-row">
        <div class="form-unit">
          <roe-service-requirement-select :design="$v.editableDesign">
          </roe-service-requirement-select>
        </div>
      </div>
    </div>
    <template v-if="showServiceRequirement(editableDesign)">
      <div class="right-panel-form-row-wrap">
        <div class="right-panel-label-wrap">
          <div class="light-label">Service Requirement for the plan</div>
        </div>
        <div class="right-panel-form-row">
          <div class="form-unit">
            <roe-service-requirement-months-input :design="$v.editableDesign">
            </roe-service-requirement-months-input>
          </div>
        </div>
      </div>

      <div class="right-panel-form-row-wrap">
        <div class="right-panel-label-wrap">
          <div class="light-label">Apply to the Employer Contribution Match</div>
        </div>
        <div class="right-panel-form-row">
          <div class="form-unit">
            <roe-service-requirement-sync-radio :design="$v.editableDesign">
            </roe-service-requirement-sync-radio>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:survey>
      <roe-survey-bar label="Immediate" :percent="survey.service_requirement.month0"></roe-survey-bar>
      <roe-survey-bar label="1 month" :percent="survey.service_requirement.month1"></roe-survey-bar>
      <roe-survey-bar label="2 month" :percent="survey.service_requirement.month2"></roe-survey-bar>
      <roe-survey-bar label="3 month" :percent="survey.service_requirement.month3"></roe-survey-bar>
      <roe-survey-bar label="4 month" :percent="survey.service_requirement.month4"></roe-survey-bar>
      <roe-survey-bar label="5 month" :percent="survey.service_requirement.month5"></roe-survey-bar>
      <roe-survey-bar label="6 month" :percent="survey.service_requirement.month6"></roe-survey-bar>
      <roe-survey-bar label="7 month" :percent="survey.service_requirement.month7"></roe-survey-bar>
      <roe-survey-bar label="8 month" :percent="survey.service_requirement.month8"></roe-survey-bar>
      <roe-survey-bar label="9 month" :percent="survey.service_requirement.month9"></roe-survey-bar>
      <roe-survey-bar label="10 month" :percent="survey.service_requirement.month10"></roe-survey-bar>
      <roe-survey-bar label="11 month" :percent="survey.service_requirement.month11"></roe-survey-bar>
      <roe-survey-bar label="12 month" :percent="survey.service_requirement.month12"></roe-survey-bar>
    </template>
  </roe-plan-design-edit-form>
</template>

<script>
import RoePlanDesignEditForm from "@/components/alternative-designs/_shared/EditForm";
import RoeSurveyBar from "@/components/charts/SurveyBar";
import { mapGetters } from "vuex";
import ServiceRequirementMixin from "@/components/_shared/inputs/design/_mixins/ServiceRequirementMixin";
import {
  RoeServiceRequirementSelect,
  RoeServiceRequirementMonthsInput,
  RoeServiceRequirementSyncRadio
} from "@/components/_shared/inputs/design/employee-contributions";
export default {
  name: "RoeServiceRequirement",
  components: {
    RoeServiceRequirementSyncRadio,
    RoeServiceRequirementSelect,
    RoeServiceRequirementMonthsInput,
    RoeSurveyBar,
    RoePlanDesignEditForm
  },
  mixins: [ServiceRequirementMixin],
  props: {
    designs: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters(["editableDesign", "serviceRequirement", "survey"])
  },
  validations() {
    return {
      editableDesign: this.serviceRequirementValidations(this.editableDesign)
    };
  }
};
</script>
